import React from 'react';

import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import styled from 'styled-components';

import { BaseError } from '../../helpers/BaseError';

import { FormulaDetailModel } from '../../models/formula.model';

import FormulaAction from './FormulaAction';

interface FormulaActionMenuProps {
    rowData: FormulaDetailModel;
    deleteFormula: UseMutationResult<
        AxiosResponse<FormulaDetailModel>,
        BaseError,
        number
    >;
    archiveFormula: UseMutationResult<
        AxiosResponse<FormulaDetailModel>,
        BaseError,
        number
    >;
    isClonePending: boolean;

    selectFormulaToClone: (value: number) => void;
    containerStyle?: React.CSSProperties;
    hasDeleteAccess: boolean;
}

const FormulaActionMenu: React.FC<
    React.PropsWithChildren<FormulaActionMenuProps>
> = ({
    rowData,
    deleteFormula,
    archiveFormula,
    selectFormulaToClone,
    containerStyle,
    isClonePending,
    hasDeleteAccess,
}) => {
    return (
        <Container style={containerStyle}>
            <FormulaAction
                key={rowData?.id}
                rowData={rowData}
                deleteFormula={deleteFormula}
                archiveFormula={archiveFormula}
                isClonePending={isClonePending}
                selectFormulaToClone={selectFormulaToClone}
                hasDeleteAccess={hasDeleteAccess}
            />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
});

export default FormulaActionMenu;
